<template>
  <v-card>
    <v-toolbar flat dense color="secondary" dark>
      <slot v-if="filters" name="filters" />
      <v-toolbar-title v-if="title" class="ml-0">
        {{ title }}
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon class="mr-2" :loading="loading" @click="$emit('refresh')">
        <v-icon>refresh</v-icon>
      </v-btn>
      <div v-if="!onlyBar" class="caption">
        <v-btn
          icon
          class="mr-0"
          :disabled="view == 'list'"
          @click="view = 'list'"
        >
          <v-icon>list</v-icon>
        </v-btn>
        <v-btn
          icon
          class="ml-0"
          :disabled="view == 'bar'"
          @click="view = 'bar'"
        >
          <v-icon>equalizer</v-icon>
        </v-btn>
      </div>
    </v-toolbar>
    <transition name="fade" mode="out-in">
      <slot v-if="view == 'list'" name="list" />
      <slot v-else-if="view == 'bar'" name="bar" />
    </transition>
  </v-card>
</template>

<script>
export default {
  name: 'StatsItem',
  props: {
    title: {
      type: String,
      default: '',
    },
    onlyBar: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      view: 'list',
    }
  },
  mounted() {
    this.width = '100%'
    if (this.onlyBar) {
      this.view = 'bar'
    }
  },
}
</script>
